import { SearchResults } from "../SearchResults";
import { useTrendingTags } from "./hooks/useTrendingTags";

export const TrendingTags = () => {
  const { trendingTags } = useTrendingTags();
  if (!trendingTags.length) {
    return null;
  }

  return (
    <SearchResults
      title="Trending Searches"
      data={trendingTags}
    />
  );
};
